import React, { PropTypes, Component } from 'react';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { findIndex, remove, intersection, difference, union } from 'lodash';

import { media } from 'style-utils';
import styled from 'styled-components';
import {
  NitroHeading,
  NitroSearchBar,
  NitroButton,
  NitroButtonGroup,
  NitroBadge,
  NitroLoading,
  NitroDrawer,
  NitroCheckbox,
  NitroPanel,
  NitroGrids,
  NitroGrid,
  NitroPlaceholder,
  NitroContentNotAvailable,
  NitroSingleSelect
} from 'nitro-components';

import { INSIGHTS } from '../../../routes/const';
import CostcentreApi from '../../../api/CostcentreApi';

import {
  FilterGroup,
  CountryFilter,
  CostcenterFilter
} from '../../../components/filter';

// Update to default role when applying with country change
import { changeCurrentRole } from '../../../auth/actions';
import {
  getCurrentRole,
  getFormatedRoles
} from '../../../components/common/Profile/selector';
import { updateCurrentRole } from '../../../components/common/Profile/utils';
import {
  setGlobalCountryCostCenter,
  setGlobalDynamicFilter
} from '../../../action/CommonActions';

// import HelpText from '../../../components/utils/HelpText';
import FilterMobileComponent from '../../../components/common/FilterMobileComponent';
import Header from '../../../components/layouts/Header';
import { notify } from '../../../components/libs/notification';
import Breakpoint from '../../../utils/breakpoints';
import { pushGAAction } from '../../../utils/gtm';

import * as actions from './actions';

import ConfirmChangesModal from './components/ConfirmChangesModal';
import VehicleCostcenterDetails from './components/VehicleCostcenterDetails';
import VehicleListDetails from './components/VehicleListDetails';

import {
  VEHICLE_SEARCH_HINT,
  RECORD_NUMBER,
  CHANGE_COSTCENTER_SUCCESS_TITLE
} from './content';

import {
  getVehicleRelocation,
  getVehicleRelocationCCAndCountry,
  getRestrictionFilter
} from './selector';

const RelocationVehicleHeader = styled.div`
  display: flex;
  justify-content: space-between;
  line-height: 47px;
  flex-direction: column;
  align-items: flex-start;
  ${media.screen`
    flex-direction: row;
    align-items: center;
  `}
`;

const VehicleList = styled.ul`
  margin: 0;
  padding: 0 16px;
  height: 400px;
  overflow-y: auto;
`;

const VehicleListItem = styled.li`
  list-style: none;
  position: relative;
  padding: 12px 0;
  border-bottom: 1px solid ${props => props.theme.color.border};
`;

const RelocationCheckbox = styled.div`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
`;

const Panel = styled.div`
  margin: 10px 0;
  border: 1px solid ${props => props.theme.color.border};
`;
const PanelListHeader = styled.div`
  position: relative;
  padding: 8px 16px;
  background-color: ${props => props.theme.color.secondary};
  min-height: 40px;
  max-height: 40px;
`;

const SelectedVehicle = styled.div`
  opacity: 0.5;
  color: ${props => props.theme.color.white};
  position: absolute;
  right: 16px;
  top: 0;
  line-height: 40px;
`;

const LoadMore = styled.div`
  height: 50px;
  line-height: 50px;
  text-align: center;
  margin: 8px 0;
  display: ${props => (props.display ? 'block' : 'none')};
`;

class VehicleCostcenterChange extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      confirm: false,
      costcenter: {},
      selectedVehicles: [],
      vehicleDetail: {},
      search: '',
      costCenterOptions: [],
      ccLookup: '',
      ccIdx: 0,
      ccLimit: 25,
      selectedResCostCenter: '',
      fetchingRestrictions: false
    };

    this.setCostcenter = this.setCostcenter.bind(this);
    this.search = this.search.bind(this);
    this.changeCostcenter = this.changeCostcenter.bind(this);
    this.selectResCostCenter = this.selectResCostCenter.bind(this);
  }

  componentDidMount() {
    this.getVehicles();
  }

  componentWillReceiveProps(nextProps) {
    if (this.allSelected && nextProps.vehicles !== this.props.vehicles) {
      this.setState({ selectedVehicles: nextProps.vehicles });
    }

    if (nextProps.avaiableCostCenter) {
      const ccSetup = {};

      if (
        nextProps.avaiableCostCenter.userRestrictions &&
        nextProps.avaiableCostCenter.userRestrictions.length > 0
      ) {
        const ccRest = nextProps.avaiableCostCenter.userRestrictions.find(
          x => x.typeId === 1
        );
        ccSetup.costCenterOptions =
          ccRest && ccRest.options ? [...ccRest.options] : [];
      }

      if (
        nextProps.avaiableCostCenter.companyHierarchy &&
        nextProps.avaiableCostCenter.companyHierarchy.length === 0
      ) {
        const selVehi = this.state.selectedVehicles[0];
        if (selVehi) {
          ccSetup.costcenter = {
            label: selVehi.CompanyName,
            value: selVehi.CompanyCode
          };
        }
      }

      this.setState(ccSetup);
    }
  }

  reset = () => {
    this.searchBar.reset();
    this.setState(
      {
        open: false,
        costcenter: {},
        selectedVehicles: [],
        vehicleDetail: {},
        search: '',
        ccLookup: '',
        ccIdx: 0,
        ccLimit: 25,
        costCenterOptions: [],
        selectedResCostCenter: '',
        confirmDisabled: false,
        fetchingRestrictions: false
      },
      this.getVehicles
    );
  };

  getVehicles = (loadMore = false, country = {}, costcenter = {}) => {
    const page = this.props.currentPage + 1;
    const offset = loadMore ? (page - 1) * RECORD_NUMBER : 0;
    const countryCode = country.value || this.props.country.value;
    const companyCode = costcenter.value || this.props.costcenter.value;
    const { restrictions } = this.props;

    const params = {
      countryCode,
      companyCode,
      offset,
      limit: RECORD_NUMBER,
      lookup: this.state.search,
      lookupType: 'Registration',
      restrictions: JSON.stringify(restrictions)
    };
    this.props.actions.fetchVehicles(params, loadMore);
  };

  setSource = filters => {
    // update role here
    const country = filters[0];
    const costcenter = filters[1];
    this.props.setGlobalCountryCostCenter({ country, costcenter });

    if (this.props.role.country !== country.value) {
      // update role when country is changed in filter
      updateCurrentRole(
        this.props.roles,
        [],
        country.value,
        'ROLEDRAWERCHANGE',
        newRole => {
          this.props.setGlobalDynamicFilter([]);
          this.props.changeCurrentRole(newRole);
          this.context.router.push(INSIGHTS);
        }
      );
    }
    this.reset();
  };

  setCostcenter = costcenter => {
    const { country } = this.props;

    if (costcenter.value !== this.state.costcenter.value) {
      this.setState({ costcenter });
      this.getCompanyDynamicFilters(country.value, costcenter.value);
    } else {
      this.setState({
        costcenter: {},
        costCenterOptions: [],
        selectedResCostCenter: ''
      });
    }
  };

  getCompanyDynamicFilters(countryCode, companyCode) {
    const costCentreResType = 1;
    this.setState({
      fetchingRestrictions: true
    });

    CostcentreApi.getCompanyRestrictionFilters(
      countryCode,
      companyCode,
      costCentreResType
    ).then(data => {
      let ccOpts = [];
      if (data && data[0]) {
        ccOpts = data[0].options.map(item => item);
      }

      this.setState({
        fetchingRestrictions: false,
        costCenterOptions: ccOpts
      });
    });
  }

  getVehicleChecked = vehicle =>
    findIndex(this.state.selectedVehicles, {
      LeaseId: vehicle.LeaseId
    }) !== -1;
  getSelectedVehiclesCompany = () => {
    const { selectedVehicles } = this.state;

    const ccode = selectedVehicles.reduce((acc, curr) => {});
  };

  updateSelected = selectedVehicles => {
    this.setState({ selectedVehicles });
  };

  get allSelected() {
    const { selectedVehicles } = this.state;
    const { vehicles } = this.props;

    if (vehicles.length === 0) {
      return false;
    }

    if (selectedVehicles.length > 0) {
      return (
        intersection(vehicles, selectedVehicles).length === vehicles.length
      );
    }

    return false;
  }
  get loadMore() {
    const { totalVehicles, currentPage } = this.props;
    return totalVehicles > currentPage * RECORD_NUMBER;
  }

  selectAllVehicles = () => {
    const { selectedVehicles } = this.state;
    const { vehicles } = this.props;
    if (this.allSelected) {
      // Do differenciate with selected and all
      this.updateSelected(difference(selectedVehicles, vehicles));
    } else {
      this.updateSelected(union(selectedVehicles, vehicles));
    }
  };

  selectVehicle = vehicle => {
    const selectedVehicles = [...this.state.selectedVehicles];
    // Remove current if checked
    if (this.getVehicleChecked(vehicle)) {
      remove(selectedVehicles, v => v.LeaseId === vehicle.LeaseId);
      this.updateSelected(selectedVehicles);
    } else {
      this.updateSelected([...selectedVehicles, vehicle]);
    }

    if (selectedVehicles.length === 0) {
      this.setState(
        {
          ccLookup: '',
          ccIdx: 0
        },
        () => {
          const { ccLookup, ccIdx, ccLimit } = this.state;
          this.props.actions.fetchVehicleCostCenter(
            this.props.country.value,
            vehicle.CompanyCode,
            ccLookup,
            ccIdx,
            ccLimit
          );
        }
      );
    }
  };

  // debDoAvailLookup = debounce(this.doAvailLookup);
  doAvailLookup = searchText => {
    console.log('search debounced', searchText);
  };
  fetchLookup = newLookup => {
    const { ccLookup, ccIdx, ccLimit, selectedVehicles } = this.state;

    this.setState(
      {
        ccLookup: newLookup,
        ccIdx: 0
      },
      () => {
        this.props.actions.fetchVehicleCostCenter(
          this.props.country.value,
          selectedVehicles[0].CompanyCode,
          newLookup,
          0,
          ccLimit
        );
      }
    );
  };

  loadMoreCC = () => {
    const { avaiableCostCenter } = this.props;
    const { ccLookup, ccIdx, ccLimit, selectedVehicles } = this.state;

    const newIdx = ccIdx + 1;
    this.setState({
      ccIdx: newIdx
    });
    const offset = newIdx * ccLimit;

    this.props.actions.fetchVehicleCostCenter(
      this.props.country.value,
      selectedVehicles[0].CompanyCode,
      ccLookup,
      parseInt(offset, 10),
      parseInt(ccLimit, 10)
    );
  };

  openSidePanel = vehicle => {
    this.props.actions.fetchVehicleDetails({
      companyCode: this.props.costcenter.value,
      countryCode: this.props.country.value,
      id: vehicle.LeaseId
    });
    this.setState({
      open: true
    });
  };

  closeSidepanel = () => {
    this.setState({
      open: false
    });
  };

  openConfirmModal = () => {
    this.setState({
      confirm: true
    });
  };

  closeConfirmModal = () => {
    this.setState({
      confirm: false
    });
  };

  showDetail = vehicle => {
    this.openSidePanel(vehicle);
  };

  search = text => {
    this.setState(
      {
        search: text.toLowerCase(),
        selectedVehicles: []
      },
      this.getVehicles
    );
  };

  changeCostcenter = () => {
    const { costcenter, selectedResCostCenter } = this.state;
    this.setState({
      confirmDisabled: true
    });
    const data = this.state.selectedVehicles.map(vehicle => {
      const {
        LeaseId,
        RegistrationNumber,
        CompanyName,
        CompanyCode,
        CostCentre
      } = vehicle;

      return {
        LeaseId,
        RegistrationNumber,
        CurrentCompanyName: CompanyName,
        CurrentCompanyCode: CompanyCode,
        NewCompanyName: costcenter.label,
        NewCompanyCode: costcenter.value,
        CurrentCostCentreCode: CostCentre,
        NewCostCentreCode: selectedResCostCenter
      };
    });

    const plurals = data.length > 1 ? 's' : '';

    // TODO: Change to success and clear state and load data again
    this.props.actions
      .changeCostcenter(this.props.country.value, data)
      .then(() => {
        this.closeConfirmModal();

        pushGAAction(
          'VEHCCALLOC',
          `VEHALLOC::${data.length}::${costcenter.label}`
        );

        this.props.notify({
          time: 12,
          title: CHANGE_COSTCENTER_SUCCESS_TITLE,
          message: `${data.length} vehicle${plurals} will be changed to ${costcenter.label}`
        });
        this.reset();
      });
  };

  selectResCostCenter = selval => {
    this.setState({
      selectedResCostCenter: selval.value
    });
  };

  render() {
    const {
      country,
      costcenter,
      fetchingVehicles,
      vehicles,
      totalVehicles,
      currentPage,
      avaiableCostCenter
    } = this.props;

    const {
      fetchingRestrictions,
      costCenterOptions,
      selectedResCostCenter,
      ccLookup
    } = this.state;

    const source = [
      {
        title: 'Country',
        label: country.label,
        value: country.value,
        component: CountryFilter
      },
      {
        title: 'Cost centre',
        label: costcenter.label,
        value: costcenter.value,
        component: CostcenterFilter,
        componentProps: {
          noDrillDown: true
        }
      }
    ];
    const ccodeSet = new Set();

    let vehicleList = vehicles.map((vehicle, index) => {
      const { selectedVehicles } = this.state;
      ccodeSet.add(vehicle.CompanyCode);
      const checked = this.getVehicleChecked(vehicle);
      let disabled = false;
      if (selectedVehicles && selectedVehicles.length > 0) {
        const ccode = selectedVehicles[0].CompanyCode;
        disabled = ccode !== vehicle.CompanyCode;
      }
      return (
        <VehicleListItem key={index}>
          <RelocationCheckbox>
            <NitroCheckbox
              variant="secondary"
              size={16}
              checked={checked}
              disabled={disabled}
              action={() => this.selectVehicle(vehicle)}
            />
          </RelocationCheckbox>
          <VehicleListDetails vehicle={vehicle} action={this.showDetail} />
        </VehicleListItem>
      );
    });

    if (currentPage === 1 && vehicles.length === 0) {
      vehicleList = <NitroContentNotAvailable />;
    }

    let total = totalVehicles;
    if (currentPage === 0 && fetchingVehicles) {
      vehicleList = null;
      total = 0;
    }

    let confirmChangeEnable = false;
    if (costCenterOptions && costCenterOptions.length > 0) {
      if (selectedResCostCenter !== '') confirmChangeEnable = true;
    } else if (this.state.costcenter.value) {
      confirmChangeEnable = true;
    }

    const showCCList =
      (avaiableCostCenter &&
        avaiableCostCenter.companyHierarchy &&
        avaiableCostCenter.companyHierarchy.length > 0) ||
      ccLookup !== '';

    return (
      <section>
        <Header>
          <NitroHeading
            header
            inline
            noMargin
            label="Vehicle cost centre change"
          />
          <Breakpoint name="desktop">
            <FilterGroup
              width="75%"
              align="right"
              action={this.setSource}
              title="Source"
              icon="source"
              filters={source}
            />
          </Breakpoint>
          <Breakpoint name="mobileTablet">
            <FilterMobileComponent
              onClickSource={this.setSource}
              source={source}
            />
          </Breakpoint>
        </Header>

        <NitroGrids>
          <NitroGrid grid={2}>
            <NitroPanel>
              <NitroHeading size="2" label="1. Select vehicles to change" />

              <RelocationVehicleHeader>
                <section>
                  <NitroHeading
                    inline
                    variant="secondary"
                    label="All available"
                    size="3"
                    noMargin
                  />
                  <NitroBadge variant="secondary" label={total} size={10} />
                </section>
                <NitroSearchBar
                  width={350}
                  ref={ref => {
                    this.searchBar = ref;
                  }}
                  action={this.search}
                  hintText={VEHICLE_SEARCH_HINT}
                />
              </RelocationVehicleHeader>

              <Panel>
                <PanelListHeader>
                  {ccodeSet.length === 1 && (
                    <NitroCheckbox
                      variant="white"
                      size={16}
                      tickVariant="secondary"
                      label="Select all"
                      maxWidth="80px"
                      checked={this.allSelected}
                      action={this.selectAllVehicles}
                    />
                  )}
                  <SelectedVehicle>
                    {`${this.state.selectedVehicles.length}`} selected
                  </SelectedVehicle>
                </PanelListHeader>

                <VehicleList>
                  {vehicleList}
                  {fetchingVehicles && !this.loadMore && (
                    <NitroLoading position="center" size={30} />
                  )}
                  <LoadMore display={this.loadMore}>
                    {fetchingVehicles ? (
                      <NitroLoading position="center" size={30} />
                    ) : (
                      <NitroButton
                        label="Load more"
                        size="compact"
                        action={() => this.getVehicles(true)}
                      />
                    )}
                  </LoadMore>
                </VehicleList>
              </Panel>
            </NitroPanel>
          </NitroGrid>

          <NitroGrid grid={2}>
            <NitroPanel disabled={this.state.selectedVehicles.length === 0}>
              <NitroHeading
                size="2"
                label="2. Specify destination cost centre"
              />
              {showCCList && (
                <div>
                  <CostcenterFilter
                    variant="primary"
                    rootCostcenter={costcenter}
                    action={this.setCostcenter}
                    filter={this.state.costcenter}
                    filters={source}
                    availableCompanies={avaiableCostCenter.companyHierarchy}
                    availableCompaniesCount={avaiableCostCenter.totalCompanies}
                    noDrillDown
                    doAvailLookup={this.fetchLookup}
                    loadMore={this.loadMoreCC}
                    lookup={ccLookup}
                  />

                  <NitroPlaceholder size={20} />
                </div>
              )}

              {costCenterOptions && costCenterOptions.length > 0 && (
                <div>
                  <NitroHeading size="3" label="Cost centre" margin="8" />
                  <NitroSingleSelect
                    placeholder="Select cost centre"
                    action={this.selectResCostCenter}
                    value={selectedResCostCenter}
                    options={costCenterOptions}
                  />
                  <NitroPlaceholder size={20} />
                </div>
              )}

              <NitroButtonGroup layout="horizontal" align="right">
                <NitroButton
                  action={this.openConfirmModal}
                  label="Confirm change"
                  variant="primary"
                  size="small"
                  disabled={!confirmChangeEnable}
                />
              </NitroButtonGroup>

              {fetchingRestrictions && (
                <NitroLoading position="center" size={30} />
              )}
            </NitroPanel>
          </NitroGrid>
        </NitroGrids>
        <NitroDrawer
          padding="32px"
          isOpen={this.state.open}
          close={this.closeSidepanel}
          width={460}
        >
          <VehicleCostcenterDetails
            vehicle={this.props.vehicleDetails}
            fetchingVehicleDetails={this.props.fetchingVehicleDetails}
          />
        </NitroDrawer>

        <ConfirmChangesModal
          open={this.state.confirm}
          close={this.closeConfirmModal}
          action={this.changeCostcenter}
          disabled={this.state.confirmDisabled}
        />
      </section>
    );
  }
}

VehicleCostcenterChange.propTypes = {
  country: PropTypes.shape({}),
  costcenter: PropTypes.shape({}),
  actions: PropTypes.shape({}),
  setGlobalCountryCostCenter: PropTypes.func,
  setGlobalDynamicFilter: PropTypes.func,
  vehicles: PropTypes.array,
  vehicleDetails: PropTypes.shape({}),
  fetchingVehicles: PropTypes.bool,
  fetchingVehicleDetails: PropTypes.bool,
  totalVehicles: PropTypes.number,
  currentPage: PropTypes.number,
  notify: PropTypes.func
};

VehicleCostcenterChange.contextTypes = {
  router: PropTypes.shape({})
};

const mapStateToProps = state => {
  const { costcenter, country } = getVehicleRelocationCCAndCountry(state);
  const {
    fetchingVehicles,
    vehicles,
    totalVehicles,
    currentPage,
    fetchingVehicleDetails,
    vehicleDetails,
    avaiableCostCenter
  } = getVehicleRelocation(state);

  const { restrictions } = getRestrictionFilter(state);

  return {
    avaiableCostCenter,
    country,
    costcenter,
    currentPage,
    fetchingVehicleDetails,
    fetchingVehicles,
    vehicleDetails,
    vehicles,
    restrictions,
    role: getCurrentRole(state),
    roles: getFormatedRoles(state),
    totalVehicles
  };
};

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(actions, dispatch),
  notify: bindActionCreators(notify, dispatch),
  changeCurrentRole: bindActionCreators(changeCurrentRole, dispatch),
  setGlobalCountryCostCenter: bindActionCreators(
    setGlobalCountryCostCenter,
    dispatch
  ),
  setGlobalDynamicFilter: bindActionCreators(setGlobalDynamicFilter, dispatch)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(VehicleCostcenterChange);



// WEBPACK FOOTER //
// ./src/features/relocations/vehicle/VehicleCostcenterChange.js